import { calculateQuantityDifference } from "../../../utils"
import { TransferVarianceReason } from "../constants"
import type { TransferReceiveFormValues } from "../schemas/receive"

import type { Transfer } from "@/graphql/codegen/graphql"

export const toTransferReceiveFormValues = (transfer: Transfer): TransferReceiveFormValues => ({
  pallets: transfer.products.flatMap(({ pallets }) =>
    pallets.map((pallet) => ({
      referenceNbr: pallet.referenceNbr,
      // TODO(AK-6103): Seed from pallet.lpn once TransferPallet exposes it.
      lpn: "",
      lots: pallet.lots.map((lot) => ({
        transferLotId: lot.transferLotId,
        qtyExpected: lot.qtyToMove ?? 0,
        // TODO(AK-6103): Preload previously saved received qty, variance reason and comments once the backend exposes them (AC8, AC12, AC13).
        qtyReceived: null,
        varianceReason: TransferVarianceReason.None,
        varianceComments: "",
      })),
    }))
  ),
})

export const filterQuantityVariancePallets = (
  pallets: TransferReceiveFormValues["pallets"]
): TransferReceiveFormValues["pallets"] =>
  pallets
    .map((pallet) => ({
      ...pallet,
      lots: pallet.lots.filter(
        ({ qtyReceived, qtyExpected }) => !!calculateQuantityDifference(qtyReceived, qtyExpected)
      ),
    }))
    .filter(({ lots }) => lots.length > 0)
